import { addCurrency } from "../../utils/currencyUtils";
import { allocateExactCents } from "../../utility/generateShapedPayoutTable";

export const smartRoundAmounts = (amounts, totalPrizeFund) =>
  allocateExactCents(amounts, totalPrizeFund);

export const calculateTotalAllocated = (payouts) => {
  return payouts.reduce(
    (total, payout) => addCurrency(total, payout.amount || 0),
    0
  );
};
